<template>
  <div class="role-box">
    <!--新增、编辑页面-->
    <role-action
      ref="roleAction"
      v-show="roleInfo.status"
      :type="type"
      :role-info="roleInfo"
      @handlerRoleList="handlerAuthorList"
      @handleClose="closeAction"
    ></role-action>
    <div v-show="!roleInfo.status">
      <!-- 操作栏 -->
      <div class="action-bar">
        <el-button type="primary" size="small" @click="authorAction('add',roleInfo)">+新增角色</el-button>
      </div>
      <!-- 表格数据 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        @sort-change="handleSortChange"
        ref="multipleTable"
      >
        <el-table-column prop="id" label="ID" align="center" min-width="140">
          <template slot-scope="scope">{{scope.row.id || '未知'}}</template>
        </el-table-column>
        <el-table-column prop="role" label="角色名" align="center" min-width="140">
          <template slot-scope="scope">{{scope.row.role || '未知'}}</template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" align="center" min-width="200px">
          <template slot-scope="scope">
            <span>{{scope.row.createdAt | changeDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200px" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              icon="el-icon-edit"
              @click="authorAction('edit',scope.row)"
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="remove(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页组件-->
      <el-pagination
        :page-sizes="[10, 15, 20, 30]"
        :current-page="param.pageNumber"
        :page-size="param.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        v-if="total > 10"
        @size-change="changeSize"
        @current-change="changeCurrent"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import RoleAction from "./components/roleAction";
import API from "@/api";
import { sortEscape } from "@/utils/global";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      // 通过props传递给子组件的参数
      type: "add",
      // 角色的详细信息
      roleInfo: {
        status: false,
        role: "",
        id: "",
        authjson: "[]",
        actJson: "[]"
      },
      // 角色管理列表请求参数
      param: {
        pageNumber: 1,
        pageSize: 10,
        key: "",
        value: ""
      }
    };
  },
  created() {
    this.getAuthorList(this.param);
  },
  components: {
    RoleAction
  },
  methods: {
    /****************************角色列表数据*****************************/
    // 删除author
    remove(id) {
      this.$confirm("您确定要删除当前角色吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        API.delAuthor({ authIDArray: [id] }).then(res => {
          if (res.code === 200) {
            this.getAuthorList();
            this.$message({
              message: "删除成功",
              type: "success"
            });
          } else if (res.code === 9200) {
            this.$message.error("该角色已绑定用户,不支持删除!");
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerAuthorList() {
      this.param.pageNumber = 1;
      this.getAuthorList();
    },
    // 请求角色管理模块配置列表
    getAuthorList(type) {
      this.loading = true;
      if (type === "status") {
        this.param.pageNumber = 1;
      }
      API.getAuthorList(this.param)
        .then(res => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.param.value = sortEscape(column.order);
      this.param.key = column.prop;
      this.getAuthorList(this.param);
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.param.pageSize = size;
      this.param.pageNumber = 1;
      this.getAuthorList(this.param);
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.param.pageNumber = pageNumber;
      this.getAuthorList(this.param);
    },
    // 新增、修改角色
    authorAction(type, row) {
      this.type = type;
      this.roleInfo.status = !this.roleInfo.status;
      this.roleInfo.authjson = row.authJson;
      this.roleInfo.actJson = row.actJson;
      this.roleInfo.role = row.role;
      this.roleInfo.id = row.id;
      this.$refs.roleAction.open();
    },
    // 关闭修改页面回调函数,清除传递子页面的参数
    closeAction() {
      // 关闭修改页面
      this.roleInfo.status = false;
      // 清空权限数据
      this.roleInfo.authjson = "[]";
      // 清空功能数据
      this.roleInfo.actJson = "[]";
      // 清除角色名
      this.roleInfo.role = "";
      // 清除角色id
      this.roleInfo.id = "";
    }
  }
};
</script>
